'use client';

import React from 'react';
import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from './CarouselArrowButtons';
import useEmblaCarousel from 'embla-carousel-react';
import Link from 'next/link';
import Image from 'next/image';
import { servizi } from '@/lib/data';
import { HiChevronRight } from 'react-icons/hi';
import { redirect } from 'next/navigation';

const Carousel = () => {
  const options = { dragFree: true, loop: true };
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <section className="embla">
      <div className="overflow-hidden max-w-[95vw]" ref={emblaRef}>
        <div className="embla__container">
          {servizi.map((servizio, index) => (
            <div
              className="cursor-pointer embla__slide flex-none lg:basis-1/3 md:basis-1/2 basis-full group overflow-hidden"
              key={index}>
              <div
                className="embla__slide__number px-8 border border-primary-900/20 rounded-xl pt-12 pb-4 bg-hero-pattern min-h-[19rem] relative overflow-hidden"
                onClick={() =>
                  redirect(
                    '/' + servizio.title.replaceAll(' ', '-').toLowerCase(),
                  )
                }>
                <Image
                  src={servizio.img}
                  fill
                  alt={servizio.title}
                  className="object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-primary-900/50 group-hover:bg-primary-500/50 transition-colors duration-300 z-30" />
                <div className="flex flex-col md:gap-3 gap-2">
                  <p className="font-alice uppercase font-bold text-2xl text-center text-white text-shadow-2xs text-shadow-black z-40 shrink-0">
                    {servizio.title}
                  </p>
                  <div className="h-px w-full bg-linear-to-r from-transparent via-white/75 to-transparent z-40" />
                  <span className="text-center text-lg tracking-wide text-white/95 text-shadow-2xs text-shadow-black font-lato font-bold z-40">
                    {servizio.dsc}
                  </span>
                </div>
                <Link
                  className="absolute font-lato bottom-5 bg-cta-100 text-white left-1/2 -translate-x-1/2 font-bold flex items-end self-center text-lg transition-colors duration-500 group-hover:text-ctext-light p-3 rounded-full text-center z-40"
                  href="#appointment">
                  Scopri di più
                  <HiChevronRight className="text-2xl" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="hidden lg:flex justify-center">
        <div className="embla__buttons gap-3">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>
      </div>
    </section>
  );
};

export default Carousel;
